/**
 * Die Ansichten des Bereichs *Kalender* (Spec 45, Fachregel 14): `wochen`
 * (Vorgabe, die vier Wochen — steht nie in der URL), `ueberfaellig` und
 * `meine` (Listen der Kalender-Seitenleiste). Reine Funktionen: aus der URL in
 * den Zustand (`parseKalenderSearch`, von `validateSearch` in `router.tsx`)
 * und aus der Ansicht in **eine** `GET /tickets`-Abfrage
 * (`ticketsQueryForView`, von `routes/Kalender.tsx`). Die Mengen definiert der
 * Server (`?overdue=`, `?assignee=me`, `?open=`) — hier steht nur, welche
 * Parameter eine Ansicht schickt, keine Teilmenge im Client.
 */

import type { TicketsFilter } from '@/features/tasks/api'

export type KalenderView = 'ueberfaellig' | 'meine'

/** `?ab=YYYY-MM-DD` — nur die Textform wird geprüft; ob es ein gültiger Tag
 * ist, entscheidet der Server (Spec 07 AK-448), dieser Client rechnet kein
 * Datum. */
const KAL_AB_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function toKalenderView(value: unknown): KalenderView | undefined {
  return value === 'ueberfaellig' || value === 'meine' ? value : undefined
}

export function toKalAb(value: unknown): string | undefined {
  return typeof value === 'string' && KAL_AB_PATTERN.test(value) ? value : undefined
}

export interface KalenderSearch {
  readonly ab?: string | undefined
  readonly view?: KalenderView | undefined
}

/** `ab` gilt nur in den vier Wochen: Mit einer Listenansicht wird er
 * verworfen, ohne Fehlermeldung (Spec 45, Testfall „Ansicht `meine` mit `ab`").
 * Beide Schlüssel stehen **immer** im Ergebnis, auch als `undefined` — nur so
 * löscht `validateSearch` einen ungültigen Rohwert aus der URL (Lehre
 * `GeldSearchParams.von`). */
export function parseKalenderSearch(search: Record<string, unknown>): KalenderSearch {
  const view = toKalenderView(search.view)
  return { ab: view === undefined ? toKalAb(search.ab) : undefined, view }
}

export function ticketsQueryForView(view: KalenderView): TicketsFilter {
  return view === 'ueberfaellig' ? { overdue: true, open: true } : { assignee: 'me', open: true }
}
